import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FocusOnLoadModule } from '../focus-on-load/focus-on-load.module';

import { IconFontModule } from '../icon-font/icon-font.module';
import { InstrumentationModule } from '../instrumentation/instrumentation.module';
import { KeyboardFocusTooltipModule } from '../keyboard-focus-tooltip/keyboard-focus-tooltip.module';
import { TextFilterModule } from '../text-filter/text-filter.module';
import { TitleAnnouncerModule } from '../title-announcer/title-announcer.module';
import { ActionsMenuComponent } from './actions-menu/actions-menu.component';
import { BatchRenderPipe } from './batch-render/batch-render.pipe';
import { ContextMenuTargetDirective } from './context-menu-target/context-menu-target.directive';
import { CreateLocationComponent } from './create-location/create-location.component';
import { DefaultLinkTargetDirective } from './default-link-target/default-link-target.directive';
import { DropdownMenuComponent, DropdownMenuItemContentDirective, DropdownMenuLinkContentDirective } from './dropdown-menu/dropdown-menu.component';
import { ExpandableListComponent, ExpandableListItemDirective } from './expandable-list/expandable-list.component';
import { ExpandingSectionDirective } from './expanding-section/expanding-section.directive';
import { FocusContextDirective } from './focus-context/focus-context.directive';
import { LocalDataSizePipe } from './local-data-size/local-data-size.pipe';
import { LocalDatePipe } from './local-date/local-date.pipe';
import { MenuComponent, MenuItemContentDirective } from './menu/menu.component';
import { PeopleCardDirective } from './people-card/people-card.directive';
import { ResponsiveRelativeDatePipe } from './responsive-relative-date/responsive-relative-date.pipe';
import { ScheduleValuePipe } from './schedule-value/schedule-value.pipe';
import { ScrollListenerDirective } from './scroll-listener/scroll-listener.directive';
import { SplitButtonComponent } from './split-button/split-button.component';
import { TabListButtonDirective, TabListComponent, TabListItemDirective } from './tab-list/tab-list.component';
import { UriEscapePipe } from './uri-escape/uri-escape.pipe';

// TODO: Break apart this 'kitchen-sink' module and separate out into individual modules-per-shareable component
// This is to help Angular optimize tree-shaking and lazy loading.
// See: https://stackoverflow.com/questions/46434830/should-i-create-a-module-per-component-in-angular-4-app
// Also see: https://medium.com/@cyrilletuzi/architecture-in-angular-projects-242606567e40
@NgModule({
    imports: [
        CommonModule,
        FocusOnLoadModule,
        IconFontModule,
        KeyboardFocusTooltipModule,
        InstrumentationModule,
        TextFilterModule,
        TitleAnnouncerModule,
        RouterModule
    ],
    declarations: [
        ActionsMenuComponent,
        BatchRenderPipe,
        ContextMenuTargetDirective,
        CreateLocationComponent,
        DefaultLinkTargetDirective,
        DropdownMenuComponent,
        DropdownMenuItemContentDirective,
        DropdownMenuLinkContentDirective,
        ExpandableListComponent,
        ExpandableListItemDirective,
        ExpandingSectionDirective,
        FocusContextDirective,
        LocalDatePipe,
        LocalDataSizePipe,
        MenuComponent,
        MenuItemContentDirective,
        PeopleCardDirective,
        ResponsiveRelativeDatePipe,
        ScheduleValuePipe,
        ScrollListenerDirective,
        SplitButtonComponent,
        TabListButtonDirective,
        TabListComponent,
        TabListItemDirective,
        UriEscapePipe
    ],
    exports: [
        ActionsMenuComponent,
        BatchRenderPipe,
        DefaultLinkTargetDirective,
        ContextMenuTargetDirective,
        CreateLocationComponent,
        DropdownMenuComponent,
        DropdownMenuItemContentDirective,
        DropdownMenuLinkContentDirective,
        ExpandableListComponent,
        ExpandableListItemDirective,
        ExpandingSectionDirective,
        FocusContextDirective,
        LocalDatePipe,
        LocalDataSizePipe,
        MenuComponent,
        MenuItemContentDirective,
        PeopleCardDirective,
        ResponsiveRelativeDatePipe,
        ScheduleValuePipe,
        ScrollListenerDirective,
        SplitButtonComponent,
        TabListButtonDirective,
        TabListComponent,
        TabListItemDirective,
        UriEscapePipe
    ]
})
export class SharedComponentsModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedComponentsModule,
            providers: [
                LocalDataSizePipe, // TODO: Refactor `Pipes` used as a `provider` to `Pipes` that use a `provider` and delete these
                ResponsiveRelativeDatePipe
            ]
        };
    }
}
